'use strict';

// lengths a vybit's message and log may be, shared by the server and the web client's forms
module.exports = {
    MESSAGE_MAX_LENGTH: 1024,
    LOG_MAX_LENGTH: 10000
};
